/** Chrome every canvas frame shares: menus, hover controls, downloads, moves. */
export default {
  // Context menu
  focusFrame: "Focus this frame",
  backToWorkspace: "Back to workspace",
  bookmarkFrame: "Bookmark",
  removeFrameBookmark: "Remove bookmark",
  editFrame: "Edit frame",
  saveFrameEdits: "Save frame edits",
  answerRequest: "Answer request",
  dismissError: "Dismiss error",
  showTaskDetails: "Show task details",
  moveToProjectMenu: "Move to project…",
  hide: "Hide",
  deleteFrameTitle: "Delete frame",
  deleteFrameDescription:
    "Permanently delete this frame? This action cannot be undone.",
  downloadFailed: "Could not download frame",
  updateFailed: "Could not update frame",
  deleteFailed: {
    one: "Could not delete frame",
    other: "Could not delete {count} frames",
  },
  moveFailed: "Could not move frame",
  tryAgain: "Try again.",
  pleaseTryAgain: "Please try again.",
  frameChangedOrRemoved: "The frame may already have changed or been removed.",
  checkConnection: "Check your connection and try again.",
  moveFailedDetail:
    "The frame may already have changed, been removed, or the destination project may no longer be available.",

  saveEditsRetry: "Your changes remain open. Please try saving again.",

  // Wall card and opened item menu
  copyFailed: "Could not copy",
  nothingToCopy: "These items have no text.",
  nothingToDownload: "This item has nothing to download.",
  openTask: "Open task",
  archiveFailed: "Could not archive",
  unarchiveFailed: "Could not unarchive",
  archived: "Archived",
  archivedItems: {
    one: "Archived {count} item",
    other: "Archived {count} items",
  },
  undo: "Undo",
  denkerLearned: "Denker learned",

  // Downloads
  downloadMarkdown: "Download Markdown…",
  downloadHtml: "Download HTML…",
  downloadTableCsv: "Download table CSV…",
  downloadNumberedTableCsv: "Download table {number} CSV…",
  downloadChartCsv: "Download chart data CSV…",
  downloadChartPng: "Download chart PNG…",
  downloadText: "Download text…",
  downloadFile: "Download file…",
  chartNotVisible: "Chart is not visible yet.",
  chartRenderFailed: "Could not render chart image.",
  clipboardEmailTo: "To: {value}",
  clipboardEmailSubject: "Subject: {value}",

  // Hover chrome and focus navigation
  newChat: "New chat",
  frameControls: "Frame controls",
  answer: "Answer",
  dismiss: "Dismiss",
  closeFrame: "Close",
  copySelection: "Copy selection",
  frameDidNotFinish: "This frame didn't finish",
  toolOptions: "{tool} options",
  moreFrames: { one: "{count} more frame", other: "{count} more frames" },
  openFrame: "Open {title}",
  openOneOf: "Open one of {title}",
  statusStreaming: "Streaming",
  statusError: "Error",
  detailDidNotLoad: "This item didn't load.",

  // Move to project
  moveToProject: "Move to project",
  closeProjectPicker: "Close project picker",
  loadingProjects: "Loading projects…",
  currentProject: "Current",
  projectNamePlaceholder: "Project name",
  newProjectName: "New project name",
  create: "Create",
  newProject: "New project",
  frameMoved: { one: "Frame moved", other: "{count} frames moved" },
  movedTo: "Moved to {project}.",
  moveFrameFailed: "Could not move this frame. Please try again.",
  createProjectFailed: "Could not create the project. Please try again.",

  // Follow-ups sent from a frame
  replyFailed: "Could not send frame follow-up",
  replyOpenInProjectSpace:
    "Open this frame in a project space, then try again.",
  replyOpenInProject: "Open this frame in its project, then try again.",
  replyNotLinked:
    "This frame is not linked to its creating agent conversation.",
  replyOpenWorkspaceChat: "Open the workspace chat, then try again.",
  replyAgentUnresolved: "This frame's originating agent could not be resolved.",
  replyAgentUnavailable:
    "This frame's original agent is no longer available for direct requests.",
  replyConversationUnavailable: "Creating agent conversation unavailable",

  // Frame type names
  frameTypeMarkdown: "Markdown",
  frameTypeHtml: "HTML",
  frameTypeQuestion: "Question",
  frameTypeCode: "Code",
  frameTypeSearch: "Search",
  frameTypeWorkflow: "Workflow",
  frameTypeImage: "Image",
  frameTypeEmail: "Email",
  frameTypeNewsletter: "Newsletter",
  frameTypeConnection: "Connection",
  frameTypeConnectionPrompt: "Connection request",
  frameTypeMemory: "Memory",
  frameTypeNote: "Note",
  frameTypeDoc: "Doc",
  frameTypeConversation: "Conversation",
  frameTypeLinkedin: "LinkedIn",
  frameTypeAgentList: "Agent list",
  frameTypeAgentSettings: "Agent settings",
  frameTypeTaskboard: "Task board",
  frameTypeGithub: "GitHub",
  frameTypeEvent: "Event",
  frameTypeAgenda: "Agenda",
  frameTypeFlight: "Flight",
  frameTypeWeather: "Weather",
  frameTypeChart: "Chart",
  frameTypeDataset: "Data",
  frameTypePreviewCard: "Preview card",
  frameTypeLinkPreview: "Link preview",
  frameTypeChat: "Chat",
  frameTypeSlack: "Slack",
  frameTypeTodo: "To-do list",
  frameTypeBoard: "Board",
  frameTypeMusic: "Music",
  frameTypeCalendar: "Calendar",
  frameTypeFile: "File",
  frameTypeTerminal: "Terminal",

  // Desktop widget
  moreCount: "+{count} more",
} as const;
